import React from 'react';

interface BrandLogoProps {
  className?: string;
  iconOnly?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ className = '', iconOnly = false }) => (
  <img
    src={`${process.env.PUBLIC_URL}/${iconOnly ? 'favicon.svg' : 'mapbl-logo.svg'}`}
    alt="mapbl"
    className={className}
  />
);

export default BrandLogo;
